__webpack_require__.p = "https://static-assets.flydata.app/72d73173e4679f9a1e8d34695a1556fd986fe07c/static/";